import { render } from "./ProductRooms.vue?vue&type=template&id=4a7e5ca9&scoped=true"
import script from "./ProductRooms.vue?vue&type=script&lang=js"
export * from "./ProductRooms.vue?vue&type=script&lang=js"

import "./ProductRooms.vue?vue&type=style&index=0&id=4a7e5ca9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7e5ca9"]])

export default __exports__